import { ApolloError } from '@apollo/client';

// Where the Ladder app is published. Share links (`/join/<CODE>`) point visitors here.
export const LADDER_APP_STORE_URL = '';
export const LADDER_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.incept.ladder';

const REFERRAL_CODE_KEY = 'SATPrac:referralCode';

// Storage can be unavailable (private mode, blocked site data); a lost code just means an empty signup field.
export const rememberReferralCode = (code: string) => {
  try {
    localStorage.setItem(REFERRAL_CODE_KEY, code);
  } catch { /* empty */ }
};

export const getRememberedReferralCode = () => {
  try {
    return localStorage.getItem(REFERRAL_CODE_KEY) ?? '';
  } catch {
    return '';
  }
};

export const forgetReferralCode = () => {
  try {
    localStorage.removeItem(REFERRAL_CODE_KEY);
  } catch { /* empty */ }
};

/**
 * The server's message for one input field of a failed mutation. Field keys come back snake_cased
 * (`referral_code`), each holding a list of messages.
 */
export const getFieldError = (error: ApolloError | undefined, field: string) => {
  const fields = (error?.graphQLErrors[0]?.extensions?.fields ?? {}) as Record<string, string[] | string>;
  const messages = fields[field];

  return Array.isArray(messages) ? messages[0] : messages;
};
